import { render, staticRenderFns } from "./ToBeNoticeBill.vue?vue&type=template&id=0d7b7710&scoped=true"
import script from "./ToBeNoticeBill.vue?vue&type=script&lang=js"
export * from "./ToBeNoticeBill.vue?vue&type=script&lang=js"
import style0 from "./ToBeNoticeBill.vue?vue&type=style&index=0&id=0d7b7710&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b7710",
  null
  
)

export default component.exports